'use strict';exports.__esModule = true;var findAgent = function findAgent()




{var agents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var city = arguments[1];var neighborhood = arguments[2];var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'agent_publish_property';
  if (!agents || !city || !neighborhood) {
    return undefined;
  }
  var agent = agents.
  find(function (item) {return (
      !!item[type] && city && neighborhood &&
      item.city.label.toLowerCase() === city.toLowerCase() &&
      neighborhood.toLowerCase() === item.neighborhood.label.toLowerCase());});


  if (agent) {
    return agent[type];
  }

  return undefined;
};exports.default =

findAgent;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyInPropertiesList/helpers.js
// module id = 1195
// module chunks = 0